export const INIT_DEFAULT_TUTORIAL_STATE = 'INIT_DEFAULT_TUTORIAL_STATE';
export const FINISH_STEP = 'FINISH_STEP';
export const GO_BACK_TO_STEP = 'GO_BACK_TO_STEP';
export const SET_TUTORIAL_STATE = 'SET_TUTORIAL_STATE';
export const RESET_TUTORIAL_STATE = 'RESET_TUTORIAL_STATE';
export const TUTORIAL_STATE_STORAGE_KEY = 'ASYNC_COIN_TUTORIAL_STATE';

const LAST_STEP = 9;

const tutorialDefaultState = {
  stepNumber: 1,
  showTutorial: true,
  tutorialFinished: false
};

function saveStateToLocalStorage (state) {
  window.localStorage.setItem(TUTORIAL_STATE_STORAGE_KEY, JSON.stringify(state));
}

function tutorialReducer (state = tutorialDefaultState, action) {
  let newState = {};

  switch (action.type) {
    case FINISH_STEP:
      newState = {...state, stepNumber: action.payload + 1, tutorialFinished: (action.payload + 1) > LAST_STEP};
      saveStateToLocalStorage(newState);

      return newState;

    case GO_BACK_TO_STEP:
      newState = {...state, stepNumber: action.payload};
      saveStateToLocalStorage(newState);

      return newState;

    case SET_TUTORIAL_STATE:
      newState = {...state, ...action.payload};
      saveStateToLocalStorage(newState);
      return newState;

    case RESET_TUTORIAL_STATE:
      newState = tutorialDefaultState;
      saveStateToLocalStorage(newState);
      return newState;

    case INIT_DEFAULT_TUTORIAL_STATE:
      saveStateToLocalStorage(state);
      return state;

    default:
      return state;
  }
}

export default tutorialReducer;



// WEBPACK FOOTER //
// ./src/storage/TutorialReducer.js